module.exports = __webpack_public_path__ + "static/media/404.e7437953.svg";